import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import { Arrow } from 'Components/Atoms/ExpandableItems/Arrow';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCombinationDatasetByFieldType } from 'Services/CombinationFieldService/CombinationFieldService';
import { getTemplateFieldsByTemplateId } from 'Services/Settings/Modules/FileGenerator/FileGeneratorSettings';
import { FILE_GENERATOR_TEMPLATES, getFileGeneratorTemplateDisplayValue } from 'Services/Settings/Modules/Helper';
import { FieldType, getFieldTypeLabel } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { EntityId } from 'Store/Settings/Entities/PropTypes';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import { getFieldsByEntityId, getFieldsById } from 'Store/Settings/Fields/Selectors';
import {createModule, fetchModules, patchModule} from 'Store/Settings/Modules/Actions';
import { getModuleFieldTypeLabelByFieldType, isFieldInModuleFieldType } from 'Store/Settings/Modules/PropTypes';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';
import styles from './FileGeneratorModuleSetting.module.sass';
import {getAddressDataset} from 'Services/AddressFieldService/AddressFieldService';

const FileGeneratorModuleSetting = ({
    entity_id, template_id,
    fields, fieldsByEntityId, modulesByEntityIdByModule,
    ...props
}: FileGeneratorModuleSettingProps) => {
    const [state, setState] = useState({
        isOpen: false,
        isEdit: false
    });

    const [data, setData] = useState<any>({
        fields: [],
        unsaved: {},
        saved: modulesByEntityIdByModule?.[entity_id]?.[template_id]?.configuration || {}
    });

    const getData = () => ({...data.saved, ...data.unsaved});
    const handleCancel = () => setData({...data, unsaved: {}});
    const handleSave = () => {
        const record = modulesByEntityIdByModule?.[entity_id]?.[template_id];
        if (record?.id) {
            props.patchModule(record?.id, {
                "configuration": getData()
            });

            return;
        }

        props.createModule({
            "entity_id": entity_id,
            "module": template_id,
            "configuration": data.unsaved
        });
    }

    useEffect(() => {
        if (state.isEdit) setState({...state, isOpen: true});
    }, [state.isEdit]);

    useEffect(() => {
        props.fetchModules();
        setData({...data, fields: getTemplateFieldsByTemplateId(template_id)}); 
    }, []);

    return <div className={`expandable manage ${state.isOpen ? 'open' : ''}`}>
        <div className={'expandable-item'}>
            <div className={'expandable-item__arrow'} onClick={() => setState({...state, isOpen: state.isEdit ? true : !state.isOpen})}>
                <Arrow />
            </div>
            <div className={'expandable-item__wrapper'}>
                <div className={'expandable-item__name'}>
                    { getFileGeneratorTemplateDisplayValue(template_id) }
                </div>

                <div className={'expandable-item__toolbox'}>
                    <EditButtons
                        onEdit={(value) => setState({...state, isEdit: value})}
                        onSave={handleSave}
                        onCancel={handleCancel}
                        onDelete={() => {}}
                        onDeleteOpen={() => {}}
                        isLoading={false}
                    />
                </div>
            </div>
        </div>
        {
            state.isOpen &&
            <div className={styles['container']}>
                {
                    data.fields?.map((item: any) => {
                        if (item.type == FieldType.Combination) {
                            return <>
                                <RowItem>
                                    <RowItemTitle>{`${item.label} (${getModuleFieldTypeLabelByFieldType(item.type)})`}</RowItemTitle>
                                    <RowItemInfo>
                                        <Field
                                            isEdit={state.isEdit}
                                            type={FieldType.Select}
                                            value={getData()[item.id]?.value || ''}
                                            onChange={(value: any) => setData({
                                                ...data,
                                                unsaved: {
                                                    ...data.unsaved,
                                                    [item.id]: {
                                                        value: value
                                                    }
                                                }
                                            })}
                                            fieldProperties={{
                                                list: fieldsByEntityId[entity_id]
                                                    ?.filter(i => isFieldInModuleFieldType(i.type, item.type))
                                                    ?.filter(i => i.status == 1)
                                                    ?.map((field: any) => ({
                                                        label: `${field?.name} (${getFieldTypeLabel(field?.type)})`,
                                                        value: field?.id
                                                    }))
                                            }}
                                        />
                                    </RowItemInfo>
                                    {
                                        item?.fields?.map(cField => <>
                                            <RowItemTitle>{`${cField.label} (${getModuleFieldTypeLabelByFieldType(cField.type)})`}</RowItemTitle>
                                            <RowItemInfo>
                                                <Field
                                                    isEdit={state.isEdit}
                                                    type={FieldType.Select}
                                                    value={getData()[item.id]?.[cField.id] || ''}
                                                    onChange={(value: any) => setData({
                                                        ...data,
                                                        unsaved: {
                                                            ...data.unsaved,
                                                            [item.id]: {
                                                                ...data.unsaved?.[item.id],
                                                                [cField.id]: value
                                                            }
                                                        }
                                                    })}
                                                    fieldProperties={{
                                                        list: fieldsByEntityId[entity_id]
                                                        ?.filter(i => i.id == getData()[item.id]?.value)
                                                        ?.map((field: any) => {
                                                            const output = {
                                                                label: `${field?.name} (${getFieldTypeLabel(field?.type)})`,
                                                                value: field?.id
                                                            };
                
                                                            if (field.type == FieldType.Combination) {
                                                                const dataset = getCombinationDatasetByFieldType(fields, field, item.type);
                
                                                                if (dataset.length == 0) return output; 
                
                                                                return {
                                                                    ...output,
                                                                    children: dataset
                                                                }
                                                            }
                
                                                            return output;
                                                        })
                                                    }}
                                                />
                                            </RowItemInfo>
                                        </>)
                                    }
                                </RowItem>
                            </>
                        }

                        return <RowItem>
                            <RowItemTitle>{`${item.label} (${getModuleFieldTypeLabelByFieldType(item.type)})`}</RowItemTitle>
                            <RowItemInfo>
                                <Field
                                    isEdit={state.isEdit}
                                    type={FieldType.Select}
                                    value={getData()[item.id]}
                                    onChange={(value: any) => setData({
                                        ...data,
                                        unsaved: {
                                            ...data.unsaved,
                                            [item.id]: value
                                        }
                                    })}
                                    fieldProperties={{
                                        list: fieldsByEntityId[entity_id]
                                        ?.filter(i => isFieldInModuleFieldType(i.type, item.type))
                                        ?.filter(i => i.status == 1)
                                        ?.map((field: any) => {
                                            const output = {
                                                label: `${field?.name} (${getFieldTypeLabel(field?.type)})`,
                                                value: field?.id
                                            };

                                            if (field.type == FieldType.Combination) {
                                                const dataset = getCombinationDatasetByFieldType(fields, field, item.type);

                                                if (dataset.length == 0) return output; 

                                                return {
                                                    ...output,
                                                    children: dataset
                                                }
                                            }

                                            if (field.type == FieldType.Address) {
                                                return {
                                                    ...output,
                                                    children: getAddressDataset(field?.id).map(i => ({
                                                        ...i,
                                                        label: `${i?.label} (${getFieldTypeLabel(field?.type)})`
                                                    }))
                                                }
                                            }

                                            return output;
                                        })
                                    }}
                                />
                            </RowItemInfo>
                        </RowItem>;
                    })
                }
            </div>
        }
    </div>;
}

interface Props {
    entity_id: EntityId,
    template_id: FILE_GENERATOR_TEMPLATES
};

const mapState = (state: StoreState) => ({
    fields: getFieldsById(state),
    fieldsByEntityId: getFieldsByEntityId(state),
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state)
});

const mapDispatch = {
    fetchFields,
    patchModule,
    createModule,
    fetchModules
};

type FileGeneratorModuleSettingProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(FileGeneratorModuleSetting);